export const stores = [
  {
    "identifier": "23725",
    "id": 3283507,
    "dateCreated": "2022-03-08T07:26:30.000+01:00",
    "lastUpdated": "2025-04-04T01:30:10.000+02:00",
    "name": "Easy Money",
    "street": "Pelham Parkway",
    "streetNo": "3536",
    "streetAndNumber": "3536 Pelham Parkway",
    "addressExtra": null,
    "zip": "35124",
    "city": "Pelham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/pelham/3536-pelham-pkwy/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "In Pelham, AL your go-to, neighborhood easymoney store on Pelham Pkwy is conveniently located and teamed with local Loan Experts who can help you find loans that fit your situation. We offer Payday Loans up to $500, Installment Loans up to $5,000, and even Title Pawn Loans up to $25,000 to qualified applicants. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. Your neighborhood easymoney store also offers check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! Stop by today to learn more. We're working hard to make it easy to access the cash and financial services you need all under one roof.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:49.000+02:00",
    "country": "US",
    "lat": 33.2666308,
    "lng": -86.8106775,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-564-7000",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284596,
        "dateCreated": "2022-04-12T16:41:45.000+02:00",
        "repoKey": "fAE7KwNkjj.jpeg",
        "locationId": 3283507,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283507/fAE7KwNkjj.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283507/medium_fAE7KwNkjj.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283507/thumb_fAE7KwNkjj.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113064888,
        "dateCreated": "2023-06-01T20:54:45.000+02:00",
        "repoKey": "DfWBt1Cf26.png",
        "locationId": 3283507,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283507/DfWBt1Cf26.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283507/DfWBt1Cf26.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283507/thumb_DfWBt1Cf26.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082295,
        "dateCreated": "2025-04-01T20:40:27.000+02:00",
        "repoKey": "ZNYBOMS1ej.png",
        "locationId": 3283507,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283507/ZNYBOMS1ej.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283507/medium_ZNYBOMS1ej.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283507/thumb_ZNYBOMS1ej.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing pelham",
      "easymoney pelham",
      "installment loans pelham",
      "payday loans pelham",
      "title loans pelham"
    ],
    "labels": [
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:29.000+01:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 877,
    "dataPoints": 33,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "26425",
    "id": 3283508,
    "dateCreated": "2022-03-08T07:26:30.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "Airport Boulevard",
    "streetNo": "7740",
    "streetAndNumber": "7740 Airport Boulevard",
    "addressExtra": "Suites A & B",
    "zip": "36608",
    "city": "Mobile",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/mobile/7740-airport-blvd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Looking for a local store with a team of Loan Experts you can trust? Look no further than the Mobile, AL easymoney location on Airport Blvd. We're standing by and ready to help when you need us. In addition to multiple loan types, we offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. Looking for a loan instead? To qualified customers, we can offer up to $500 through a Payday Loan, up to $5,000 through an Installment Loan, or even up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. Stop by the store to learn more. We work hard to make the process easy.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:49.000+02:00",
    "country": "US",
    "lat": 30.68419155,
    "lng": -88.22388331,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 251-308-7023",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284569,
        "dateCreated": "2022-04-12T16:41:26.000+02:00",
        "repoKey": "T67JQJeivd.jpeg",
        "locationId": 3283508,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283508/T67JQJeivd.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283508/medium_T67JQJeivd.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283508/thumb_T67JQJeivd.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113077236,
        "dateCreated": "2023-06-02T15:01:15.000+02:00",
        "repoKey": "XgjdjLFT1w.png",
        "locationId": 3283508,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283508/XgjdjLFT1w.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283508/XgjdjLFT1w.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283508/thumb_XgjdjLFT1w.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082299,
        "dateCreated": "2025-04-01T20:40:28.000+02:00",
        "repoKey": "FD0pL7s5ee.png",
        "locationId": 3283508,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283508/FD0pL7s5ee.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283508/medium_FD0pL7s5ee.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283508/thumb_FD0pL7s5ee.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing mobile",
      "easymoney mobile",
      "installment loans mobile",
      "payday loans mobile",
      "title loans mobile"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:29.000+01:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 887,
    "dataPoints": 75,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "21425",
    "id": 3283511,
    "dateCreated": "2022-03-08T07:26:31.000+01:00",
    "lastUpdated": "2025-04-03T00:29:45.000+02:00",
    "name": "Easy Money",
    "street": "Grace Street",
    "streetNo": "217",
    "streetAndNumber": "217 Grace Street",
    "addressExtra": null,
    "zip": "36203",
    "city": "Oxford",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/oxford/217-grace-st/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Stop by the easymoney location on Grace Street in Oxford, AL anytime you need quick, easy access to cash or financial services. You can apply for loans in-store and if approved receive up to $500 through a Payday Loan, an installment loan up to $5,000, or even up to $25,000 if you opt for an easymoney Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. Our local Loan Experts are looking forward to answering your questions and walking you through the loan process. Not looking for a loan at the moment? We offer checking cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! When you need cash, we'll make the process easy at easymoney.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:49.000+02:00",
    "country": "US",
    "lat": 33.60355372,
    "lng": -85.83135778,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 256-403-2400",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284571,
        "dateCreated": "2022-04-12T16:41:28.000+02:00",
        "repoKey": "0B9O1D87UJ.jpeg",
        "locationId": 3283511,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283511/0B9O1D87UJ.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283511/medium_0B9O1D87UJ.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283511/thumb_0B9O1D87UJ.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113077090,
        "dateCreated": "2023-06-02T14:53:09.000+02:00",
        "repoKey": "pqL5YcYUzh.png",
        "locationId": 3283511,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283511/pqL5YcYUzh.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283511/pqL5YcYUzh.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283511/thumb_pqL5YcYUzh.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082286,
        "dateCreated": "2025-04-01T20:40:26.000+02:00",
        "repoKey": "wee9TkMSd4.png",
        "locationId": 3283511,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283511/wee9TkMSd4.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283511/medium_wee9TkMSd4.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283511/thumb_wee9TkMSd4.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing oxford",
      "easymoney oxford",
      "installment loans oxford",
      "payday loans oxford",
      "title loans oxford"
    ],
    "labels": [
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:31.000+01:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 884,
    "dataPoints": 154,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Chicago"
  },
  {
    "identifier": "20286",
    "id": 3283512,
    "dateCreated": "2022-03-08T07:26:31.000+01:00",
    "lastUpdated": "2025-04-04T01:30:10.000+02:00",
    "name": "Easy Money",
    "street": "Memorial Boulevard",
    "streetNo": "1641",
    "streetAndNumber": "1641 Memorial Boulevard",
    "addressExtra": null,
    "zip": "37129",
    "city": "Murfreesboro",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/tn/murfreesboro/1641-memorial-blvd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "In need of cash fast? Don't worry, we've got your back! If approved for a Payday Loan you could access up to $425. We offer various financial services ranging from check cashing and money orders to wire transfers and Green Dot Visa® Debit Cards. We also offer bill pay services you can count on! Chat with our Loan Experts for more details! As your trusted local lender, our mission is to provide exceptional service and to make access to the cash you need quick and easy.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:49.000+02:00",
    "country": "US",
    "lat": 35.86644239,
    "lng": -86.388635,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 615-203-7000",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284583,
        "dateCreated": "2022-04-12T16:41:36.000+02:00",
        "repoKey": "rLpubVI8FO.jpeg",
        "locationId": 3283512,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283512/rLpubVI8FO.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283512/medium_rLpubVI8FO.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283512/thumb_rLpubVI8FO.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113077101,
        "dateCreated": "2023-06-02T14:53:38.000+02:00",
        "repoKey": "RHEleDYY3E.png",
        "locationId": 3283512,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283512/RHEleDYY3E.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283512/RHEleDYY3E.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283512/thumb_RHEleDYY3E.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082290,
        "dateCreated": "2025-04-01T20:40:26.000+02:00",
        "repoKey": "M2ey3GsKSL.png",
        "locationId": 3283512,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283512/M2ey3GsKSL.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283512/medium_M2ey3GsKSL.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283512/thumb_M2ey3GsKSL.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing murfreesboro",
      "easymoney murfreesboro",
      "line of credit murfreesboro",
      "payday loans murfreesboro",
      "title loans murfreesboro"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Tennessee",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyTN",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:31.000+01:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 857,
    "dataPoints": 284,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "TN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "22225",
    "id": 3283510,
    "dateCreated": "2022-03-08T07:26:31.000+01:00",
    "lastUpdated": "2025-04-04T01:30:10.000+02:00",
    "name": "Easy Money",
    "street": "Memorial Parkway Southwest",
    "streetNo": "11713",
    "streetAndNumber": "11713 Memorial Parkway Southwest",
    "addressExtra": null,
    "zip": "35803",
    "city": "Huntsville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/huntsville/11713-memorial-pkwy-southwest/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "The team at easymoney on Memorial Pkwy in Huntsville, AL is standing by and ready to help. At easymoney, we work hard to make the process easy when you need access to cash or other financial services such as check cashing, wire transfers, money orders, bill pay, or Green Dot Visa® Debit Cards. If you need cash quickly, consider our loan options. Once approved you can receive up to $500 through a Payday Loan, up to $5,000 through an Installment Loan, or even up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. Our goal is to help all our neighbors when they need us, so stop by today to discuss your situation with a team member. We're here for you!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:49.000+02:00",
    "country": "US",
    "lat": 34.61638887,
    "lng": -86.56669169,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 256-203-7041",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284570,
        "dateCreated": "2022-04-12T16:41:26.000+02:00",
        "repoKey": "slO8aDcPKg.jpeg",
        "locationId": 3283510,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283510/slO8aDcPKg.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283510/medium_slO8aDcPKg.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283510/thumb_slO8aDcPKg.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113077228,
        "dateCreated": "2023-06-02T14:59:44.000+02:00",
        "repoKey": "0s0eqnMPO9.png",
        "locationId": 3283510,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283510/0s0eqnMPO9.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283510/0s0eqnMPO9.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283510/thumb_0s0eqnMPO9.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082303,
        "dateCreated": "2025-04-01T20:40:28.000+02:00",
        "repoKey": "DMPlSx8YM8.png",
        "locationId": 3283510,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283510/DMPlSx8YM8.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283510/medium_DMPlSx8YM8.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283510/thumb_DMPlSx8YM8.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing huntsville",
      "easymoney huntsville",
      "installment loans huntsville",
      "payday loans huntsville",
      "title loans huntsville"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:30.000+01:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 869,
    "dataPoints": 94,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "24325",
    "id": 3283513,
    "dateCreated": "2022-03-08T07:26:32.000+01:00",
    "lastUpdated": "2025-04-04T01:30:10.000+02:00",
    "name": "Easy Money",
    "street": "Montgomery Highway",
    "streetNo": "2869",
    "streetAndNumber": "2869 Montgomery Highway",
    "addressExtra": null,
    "zip": "36303",
    "city": "Dothan",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/dothan/2869-montgomery-hwy/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "The Dothan, AL easymoney location located on Montgomery Highway is your go-to neighborhood store, and our team of Loan Experts are available to help you find solutions to your unique financial situation. Do you need access to cash? Once approved through our simple application process, perhaps a Payday Loan up to $500, an Installment Loan for up to $5,000, or a Title Pawn Loan for up to $25,000 could be the solution. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. Not interested in a loan at this time? We also offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! We're here to help, and we work hard to make the process easy. So, stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:49.000+02:00",
    "country": "US",
    "lat": 31.24813462,
    "lng": -85.42442423,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 334-635-1222",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284598,
        "dateCreated": "2022-04-12T16:41:46.000+02:00",
        "repoKey": "dpcONpXUXd.jpeg",
        "locationId": 3283513,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283513/dpcONpXUXd.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283513/medium_dpcONpXUXd.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283513/thumb_dpcONpXUXd.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113077119,
        "dateCreated": "2023-06-02T14:54:14.000+02:00",
        "repoKey": "lsx7vcEFKv.png",
        "locationId": 3283513,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283513/lsx7vcEFKv.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283513/lsx7vcEFKv.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283513/thumb_lsx7vcEFKv.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082276,
        "dateCreated": "2025-04-01T20:40:24.000+02:00",
        "repoKey": "MXYR3XEx1k.png",
        "locationId": 3283513,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283513/MXYR3XEx1k.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283513/medium_MXYR3XEx1k.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283513/thumb_MXYR3XEx1k.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing dothan",
      "easymoney dothan",
      "installment loans dothan",
      "payday loans dothan",
      "title loans dothan"
    ],
    "labels": [
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:32.000+01:00",
    "averageRating": 4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 871,
    "dataPoints": 100,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/Syowa"
  },
  {
    "identifier": "23525",
    "id": 3283515,
    "dateCreated": "2022-03-08T07:26:32.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "Eastern Boulevard",
    "streetNo": "1310",
    "streetAndNumber": "1310 Eastern Boulevard",
    "addressExtra": null,
    "zip": "36117",
    "city": "Montgomery",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/montgomery/1310-eastern-blvd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "We work hard to make the process easy when you need access to cash. Visit your neighborhood easymoney store on Eastern Boulevard in Montgomery, AL and connect with a local Loan Expert to learn more. Our store offers Payday Loans up to $500, Installment Loans up to $5,000, and Title Pawn Loans up to $25,000 to qualified applicants. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. We also offer an array of in-store services for your convenience such as check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! When you need a helping hand, look no further than your neighbors at easymoney. Stop by today for more information!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:49.000+02:00",
    "country": "US",
    "lat": 32.35897253,
    "lng": -86.21673495,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 334-523-7020",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284574,
        "dateCreated": "2022-04-12T16:41:30.000+02:00",
        "repoKey": "Cvpp9wFDqB.jpeg",
        "locationId": 3283515,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283515/Cvpp9wFDqB.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283515/medium_Cvpp9wFDqB.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283515/thumb_Cvpp9wFDqB.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113065481,
        "dateCreated": "2023-06-01T22:17:13.000+02:00",
        "repoKey": "yZhllbQSTZ.png",
        "locationId": 3283515,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283515/yZhllbQSTZ.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283515/yZhllbQSTZ.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283515/thumb_yZhllbQSTZ.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082313,
        "dateCreated": "2025-04-01T20:40:30.000+02:00",
        "repoKey": "ngDl75EvvJ.png",
        "locationId": 3283515,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283515/ngDl75EvvJ.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283515/medium_ngDl75EvvJ.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283515/thumb_ngDl75EvvJ.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing montgomery",
      "easymoney montgomery",
      "installment loans montgomery",
      "payday loans montgomery",
      "title loans montgomery"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:32.000+01:00",
    "averageRating": 4.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 874,
    "dataPoints": 81,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "24125",
    "id": 3283514,
    "dateCreated": "2022-03-08T07:26:32.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "Boll Weevil Circle",
    "streetNo": "604",
    "streetAndNumber": "604 Boll Weevil Circle",
    "addressExtra": null,
    "zip": "36330",
    "city": "Enterprise",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/enterprise/604-boll-weevil-circle/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "If you need quick, easy access to cash, look no further than your neighborhood easymoney store located on Boll Weevil Circle in Enterprise, AL. Our team of local Loan Experts are ready to answer your questions and help you any time. Stop by the store today to complete our simple application and once approved you can access up to $25,000 through a Title Pawn Loan, up to $5,000 through an Installment Loan, or up to $500 through a Payday Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. If you're not looking for a loan, we offer an array of in-store services for your convenience. We offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! We know that you're on the move and busy most of the time, so a quick stop by easymoney shouldn't be hard. That's why we work hard to make it easy.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:49.000+02:00",
    "country": "US",
    "lat": 31.31614787,
    "lng": -85.82948345,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 334-489-7000",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284593,
        "dateCreated": "2022-04-12T16:41:42.000+02:00",
        "repoKey": "6A03PZb4eQ.jpeg",
        "locationId": 3283514,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283514/6A03PZb4eQ.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283514/medium_6A03PZb4eQ.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283514/thumb_6A03PZb4eQ.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113065479,
        "dateCreated": "2023-06-01T22:16:39.000+02:00",
        "repoKey": "tJ4o4DYwc3.png",
        "locationId": 3283514,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283514/tJ4o4DYwc3.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283514/tJ4o4DYwc3.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283514/thumb_tJ4o4DYwc3.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082311,
        "dateCreated": "2025-04-01T20:40:30.000+02:00",
        "repoKey": "j0ioUPTzCy.png",
        "locationId": 3283514,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283514/j0ioUPTzCy.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283514/medium_j0ioUPTzCy.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283514/thumb_j0ioUPTzCy.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing enterprise",
      "easymoney enterprise",
      "installment loans enterprise",
      "payday loans enterprise",
      "title loans enterprise"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:32.000+01:00",
    "averageRating": 3.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 870,
    "dataPoints": 34,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/Syowa"
  },
  {
    "identifier": "25186",
    "id": 3283517,
    "dateCreated": "2022-03-08T07:26:33.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "Brainerd Road",
    "streetNo": "5707",
    "streetAndNumber": "5707 Brainerd Road",
    "addressExtra": null,
    "zip": "37411",
    "city": "Chattanooga",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/tn/chattanooga/5707-brainerd-rd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "easymoney is more than just your go-to local lender, we offer an array of financial services to meet your needs. You could qualify for a Payday Loan up to $425. Apply at our store on Brainerd Road to start the process today. The Loan Experts at our Chattanooga, TN store are eager to answer your questions and walk you through the process. In addition to being your favorite easy money loan company, we offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! We'd love to meet our neighbors, come on by when you need cash fast.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:48.000+02:00",
    "country": "US",
    "lat": 35.01221035,
    "lng": -85.21356021,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 423-805-9177",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284576,
        "dateCreated": "2022-04-12T16:41:32.000+02:00",
        "repoKey": "2NRCBHtLvq.jpeg",
        "locationId": 3283517,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283517/2NRCBHtLvq.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283517/medium_2NRCBHtLvq.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283517/thumb_2NRCBHtLvq.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113076155,
        "dateCreated": "2023-06-02T14:29:16.000+02:00",
        "repoKey": "ObJ1zIOca1.png",
        "locationId": 3283517,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283517/ObJ1zIOca1.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283517/ObJ1zIOca1.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283517/thumb_ObJ1zIOca1.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082275,
        "dateCreated": "2025-04-01T20:40:24.000+02:00",
        "repoKey": "rchOAMcMAx.png",
        "locationId": 3283517,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283517/rchOAMcMAx.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283517/medium_rchOAMcMAx.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283517/thumb_rchOAMcMAx.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing chattanooga",
      "easymoney chattanooga",
      "line of credit chattanooga",
      "payday loans chattanooga",
      "title loans chattanooga"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Tennessee",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "EasyMoneyTN",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:32.000+01:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 874,
    "dataPoints": 73,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "TN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/Syowa"
  },
  {
    "identifier": "27286",
    "id": 3283516,
    "dateCreated": "2022-03-08T07:26:33.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "North Roan Street",
    "streetNo": "2221",
    "streetAndNumber": "2221 North Roan Street",
    "addressExtra": "Suite 1",
    "zip": "37601",
    "city": "Johnson City",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/tn/johnson-city/2221-north-roan-st/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "easymoney has a store near you, conveniently located in Johnson City, TN on North Roan Street! You could qualify for a Payday Loan up to $425. We offer various financial services ranging from check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! Chat with our knowledgeable Loan Experts for more details! As your trusted community lender, our goal is to make access to the cash you need quick and easy.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:48.000+02:00",
    "country": "US",
    "lat": 36.34408491,
    "lng": -82.37735999,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 423-491-7100",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284585,
        "dateCreated": "2022-04-12T16:41:38.000+02:00",
        "repoKey": "XmsvDhbj5I.jpeg",
        "locationId": 3283516,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283516/XmsvDhbj5I.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283516/medium_XmsvDhbj5I.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283516/thumb_XmsvDhbj5I.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113077160,
        "dateCreated": "2023-06-02T14:55:43.000+02:00",
        "repoKey": "QcapU6LHdh.png",
        "locationId": 3283516,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283516/QcapU6LHdh.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283516/QcapU6LHdh.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283516/thumb_QcapU6LHdh.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082279,
        "dateCreated": "2025-04-01T20:40:24.000+02:00",
        "repoKey": "zhpiqf5sE2.png",
        "locationId": 3283516,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283516/zhpiqf5sE2.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283516/medium_zhpiqf5sE2.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283516/thumb_zhpiqf5sE2.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing johnson city",
      "easymoney johnson city",
      "line of credit johnson city",
      "payday loans johnson city",
      "title loans johnson city"
    ],
    "labels": [
      {
        "name": "EasyMoneyTN",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Tennessee",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:32.000+01:00",
    "averageRating": 2.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 890,
    "dataPoints": 27,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "TN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/Syowa"
  },
  {
    "identifier": "23986",
    "id": 3283518,
    "dateCreated": "2022-03-08T07:26:33.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "Lebanon Pike",
    "streetNo": "2843B",
    "streetAndNumber": "2843B Lebanon Pike",
    "addressExtra": null,
    "zip": "37214",
    "city": "Nashville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/tn/nashville/2843b-lebanon-pike/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "easymoney is more than just your go-to community lender, we offer various financial services to meet your needs. Speak to our knowledgeable Loan Experts about how you could qualify for a Payday Loan up to $425. We are conveniently located in your neighborhood for ease of access and offer more than just loans. We offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! Our enthusiastic Loan Experts are ready to walk you through the process and support you on your financial journey. Visit our store for more details!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:48.000+02:00",
    "country": "US",
    "lat": 36.16728237,
    "lng": -86.65853824,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 615-823-7866",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284605,
        "dateCreated": "2022-04-12T16:41:50.000+02:00",
        "repoKey": "FbtdGdWAMz.jpeg",
        "locationId": 3283518,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283518/FbtdGdWAMz.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283518/medium_FbtdGdWAMz.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283518/thumb_FbtdGdWAMz.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113076160,
        "dateCreated": "2023-06-02T14:30:02.000+02:00",
        "repoKey": "IoS4Gmc954.png",
        "locationId": 3283518,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283518/IoS4Gmc954.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283518/IoS4Gmc954.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283518/thumb_IoS4Gmc954.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082305,
        "dateCreated": "2025-04-01T20:40:29.000+02:00",
        "repoKey": "beGYMohiUn.png",
        "locationId": 3283518,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283518/beGYMohiUn.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283518/medium_beGYMohiUn.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283518/thumb_beGYMohiUn.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing nashville",
      "easymoney nashville",
      "line of credit nashville",
      "payday loans nashville",
      "title loans nashville"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyTN",
        "adminOnly": true
      },
      {
        "name": "Tennessee",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:33.000+01:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 869,
    "dataPoints": 113,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "TN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "24386",
    "id": 3283519,
    "dateCreated": "2022-03-08T07:26:34.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "Nolensville Road",
    "streetNo": "4211",
    "streetAndNumber": "4211 Nolensville Road",
    "addressExtra": null,
    "zip": "37211",
    "city": "Nashville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/tn/nashville/4211-nolensville-rd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "easymoney stores are conveniently located throughout Nashville, TN. The representatives at our cash center on Nolensville Pike are eager to help and ready to answer your financial questions! Ask about how you can qualify for a Payday Loan up to $425. We also have financial services you can count on! We offer various services ranging from check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. Chat with our exceptional Loan Experts for more details!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:48.000+02:00",
    "country": "US",
    "lat": 36.07591278,
    "lng": -86.72581058,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 615-781-2615",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284575,
        "dateCreated": "2022-04-12T16:41:32.000+02:00",
        "repoKey": "8gLJkgB3AM.jpeg",
        "locationId": 3283519,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283519/8gLJkgB3AM.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283519/medium_8gLJkgB3AM.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283519/thumb_8gLJkgB3AM.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113076162,
        "dateCreated": "2023-06-02T14:30:41.000+02:00",
        "repoKey": "0rsh9a9LOg.png",
        "locationId": 3283519,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283519/0rsh9a9LOg.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283519/0rsh9a9LOg.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283519/thumb_0rsh9a9LOg.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082277,
        "dateCreated": "2025-04-01T20:40:24.000+02:00",
        "repoKey": "frJna0MTyN.png",
        "locationId": 3283519,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283519/frJna0MTyN.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283519/medium_frJna0MTyN.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283519/thumb_frJna0MTyN.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing nashville",
      "easymoney nashville",
      "line of credit nashville",
      "payday loans nashville",
      "title loans nashville"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "EasyMoneyTN",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Tennessee",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:33.000+01:00",
    "averageRating": 4.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 867,
    "dataPoints": 60,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "TN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "22186",
    "id": 3283520,
    "dateCreated": "2022-03-08T07:26:34.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "Getwell Road",
    "streetNo": "4109",
    "streetAndNumber": "4109 Getwell Road",
    "addressExtra": null,
    "zip": "38118",
    "city": "Memphis",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/tn/memphis/4109-getwell-rd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "easymoney stores are conveniently located across the state, from Nashville up into the Smoky mountains of Eastern TN including our store on Getwell Road in Memphis. We offer various financial services ranging from check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. If you're in need of cash fast, you could qualify for a Payday Loan up to $425. Chat with our enthusiastic Loan Experts for more details!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:48.000+02:00",
    "country": "US",
    "lat": 35.03626879,
    "lng": -89.93768367,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 901-360-8883",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284620,
        "dateCreated": "2022-04-12T16:42:00.000+02:00",
        "repoKey": "wMsD63MMJi.jpeg",
        "locationId": 3283520,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283520/wMsD63MMJi.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283520/medium_wMsD63MMJi.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283520/thumb_wMsD63MMJi.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113076164,
        "dateCreated": "2023-06-02T14:31:32.000+02:00",
        "repoKey": "EABX6rZ060.png",
        "locationId": 3283520,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283520/EABX6rZ060.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283520/EABX6rZ060.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283520/thumb_EABX6rZ060.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082292,
        "dateCreated": "2025-04-01T20:40:27.000+02:00",
        "repoKey": "tCk2jQpH7S.png",
        "locationId": 3283520,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283520/tCk2jQpH7S.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283520/medium_tCk2jQpH7S.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283520/thumb_tCk2jQpH7S.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing memphis",
      "easymoney memphis",
      "line of credit memphis",
      "payday loans memphis",
      "title loans memphis"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Tennessee",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyTN",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:34.000+01:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 881,
    "dataPoints": 66,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "TN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "26825",
    "id": 3283521,
    "dateCreated": "2022-03-08T07:26:34.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "Azalea Road",
    "streetNo": "393",
    "streetAndNumber": "393 Azalea Road",
    "addressExtra": null,
    "zip": "36609",
    "city": "Mobile",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/mobile/393-azalea-rd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Pop by the Azalea Rd location of easymoney in Mobile, AL the next time you need access to cash quickly and easily. If you're approved (don't worry the approval process is simple) you can access up to $500 through a Payday Loan, up to $5,000 through an Installment Loan, or up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. We also offer multiple financial services in store to meet your needs quickly and easily such as: check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! When you need a little help, we're here for you. We look forward to meeting you, neighbor.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:48.000+02:00",
    "country": "US",
    "lat": 30.67010729,
    "lng": -88.14972578,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 251-343-7070",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284591,
        "dateCreated": "2022-04-12T16:41:41.000+02:00",
        "repoKey": "SNkuO65Le7.jpeg",
        "locationId": 3283521,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283521/SNkuO65Le7.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283521/medium_SNkuO65Le7.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283521/thumb_SNkuO65Le7.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113076171,
        "dateCreated": "2023-06-02T14:32:09.000+02:00",
        "repoKey": "eHdrDgO1KB.png",
        "locationId": 3283521,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283521/eHdrDgO1KB.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283521/eHdrDgO1KB.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283521/thumb_eHdrDgO1KB.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082301,
        "dateCreated": "2025-04-01T20:40:28.000+02:00",
        "repoKey": "2328RMVfLj.png",
        "locationId": 3283521,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283521/2328RMVfLj.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283521/medium_2328RMVfLj.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283521/thumb_2328RMVfLj.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing mobile",
      "easymoney mobile",
      "installment loans mobile",
      "payday loans mobile",
      "title loans mobile"
    ],
    "labels": [
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:34.000+01:00",
    "averageRating": 0,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "SUSPENDED"
      }
    ],
    "visibilityIndex": 866,
    "dataPoints": 0,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Chicago"
  },
  {
    "identifier": "21325",
    "id": 3283523,
    "dateCreated": "2022-03-08T07:26:35.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "Quintard Avenue",
    "streetNo": "2008",
    "streetAndNumber": "2008 Quintard Avenue",
    "addressExtra": null,
    "zip": "36201",
    "city": "Anniston",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/anniston/2008-quintard-ave/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "At easymoney, we offer more than the typical lender. We're eager to be your go-to neighborhood lender. We offer a wide range of financial services that will meet your needs. Drop by the Anniston, AL easymoney store located on Quintard Ave and find out what makes us different. You can apply for loans in-store and if approved receive up to $500 through a Payday Loan, an installment loan up to $5,000, or even up to $25,000 if you opt for an easymoney Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. Our local Loan Experts are looking forward to answering your questions and walking you through the loan process. Not looking for a loan at the moment? We offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! When you need cash, we'll make the process easy at easymoney.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:48.000+02:00",
    "country": "US",
    "lat": 33.67088896,
    "lng": -85.82724669,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 256-403-2420",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284614,
        "dateCreated": "2022-04-12T16:41:57.000+02:00",
        "repoKey": "H4AcPdjIcu.jpeg",
        "locationId": 3283523,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283523/H4AcPdjIcu.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283523/medium_H4AcPdjIcu.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283523/thumb_H4AcPdjIcu.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113064767,
        "dateCreated": "2023-06-01T20:44:13.000+02:00",
        "repoKey": "xoVisXIJH4.png",
        "locationId": 3283523,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283523/xoVisXIJH4.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283523/xoVisXIJH4.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283523/thumb_xoVisXIJH4.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082298,
        "dateCreated": "2025-04-01T20:40:28.000+02:00",
        "repoKey": "pXH3Pes1WB.png",
        "locationId": 3283523,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283523/pXH3Pes1WB.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283523/medium_pXH3Pes1WB.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283523/thumb_pXH3Pes1WB.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing anniston",
      "easymoney anniston",
      "installment loans anniston",
      "payday loans anniston",
      "title loans anniston"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:35.000+01:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 875,
    "dataPoints": 202,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/Syowa"
  },
  {
    "identifier": "24186",
    "id": 3283528,
    "dateCreated": "2022-03-08T07:26:36.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "Gallatin Avenue",
    "streetNo": "718",
    "streetAndNumber": "718 Gallatin Avenue",
    "addressExtra": null,
    "zip": "37206",
    "city": "Nashville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/tn/nashville/718-gallatin-ave/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Life gets hectic sometimes, and when it does, we're here to support you. easymoney makes finding your local community lender easy, we're located in Nashville, TN on Gallatin Ave! If approved for a Payday Loan you could access up to $425. In addition to being your favorite easy money loan company, we offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. The Loan Experts at our Nashville store are eager to answer your questions and walk you through the process. We'd love to meet our neighbors, come on by when you need cash fast!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:47.000+02:00",
    "country": "US",
    "lat": 36.18511424,
    "lng": -86.74816031,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 615-913-4166",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284573,
        "dateCreated": "2022-04-12T16:41:30.000+02:00",
        "repoKey": "nQ0PaKKNra.jpeg",
        "locationId": 3283528,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283528/nQ0PaKKNra.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283528/medium_nQ0PaKKNra.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283528/thumb_nQ0PaKKNra.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113076694,
        "dateCreated": "2023-06-02T14:35:52.000+02:00",
        "repoKey": "1GJwNMOTg7.png",
        "locationId": 3283528,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283528/1GJwNMOTg7.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283528/1GJwNMOTg7.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283528/thumb_1GJwNMOTg7.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082278,
        "dateCreated": "2025-04-01T20:40:24.000+02:00",
        "repoKey": "Xz9rQLjab6.png",
        "locationId": 3283528,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283528/Xz9rQLjab6.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283528/medium_Xz9rQLjab6.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283528/thumb_Xz9rQLjab6.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing gallatin",
      "easymoney gallatin",
      "line of credit gallatin",
      "payday loans gallatin",
      "title loans gallatin"
    ],
    "labels": [
      {
        "name": "EasyMoneyTN",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Tennessee",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:36.000+01:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 119,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "TN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "24086",
    "id": 3283529,
    "dateCreated": "2022-03-08T07:26:36.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "Fort Campbell Boulevard",
    "streetNo": "1607",
    "streetAndNumber": "1607 Fort Campbell Boulevard",
    "addressExtra": null,
    "zip": "37042",
    "city": "Clarksville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/tn/clarksville/1607-fort-campbell-blvd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "We understand that emergencies happen, and when they do, we make access to cash easy. You could qualify for a Payday Loan up to $425. We are proud to say that we have two easymoney stores in Clarksville, TN! Apply at either store to start the process today! The Loan Experts at our Campbell Blvd location would love to walk you through the application process. Not looking for a loan right now? We are more than just a loan company, we offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! We're here to support you on your financial journey.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:47.000+02:00",
    "country": "US",
    "lat": 36.57600748,
    "lng": -87.4074065,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 931-538-1411",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139082291,
        "dateCreated": "2025-04-01T20:40:26.000+02:00",
        "repoKey": "FoAObkoPKR.png",
        "locationId": 3283529,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283529/FoAObkoPKR.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283529/medium_FoAObkoPKR.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283529/thumb_FoAObkoPKR.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      },
      {
        "id": 95284588,
        "dateCreated": "2022-04-12T16:41:40.000+02:00",
        "repoKey": "sGL5Kafgk3.jpeg",
        "locationId": 3283529,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283529/sGL5Kafgk3.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283529/medium_sGL5Kafgk3.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283529/thumb_sGL5Kafgk3.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      }
    ],
    "keywords": [
      "check cashing clarksville",
      "easymoney clarksville",
      "line of credit clarksville",
      "payday loans clarksville",
      "title loans clarksville"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyTN",
        "adminOnly": true
      },
      {
        "name": "Tennessee",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:36.000+01:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 879,
    "dataPoints": 190,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "TN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "23425",
    "id": 3283526,
    "dateCreated": "2022-03-08T07:26:36.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "East South Boulevard",
    "streetNo": "2449",
    "streetAndNumber": "2449 East South Boulevard",
    "addressExtra": null,
    "zip": "36116",
    "city": "Montgomery",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/montgomery/2449-east-south-blvd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Looking for solutions to your situation and need cash quickly? The E. South Blvd location of easymoney in Montgomery, AL is your go-to neighborhood store with a team of Loan Experts who would love to help. We work hard to help all our neighbors with multiple loan options and in-store services for your convenience. Stop by the store today to complete our simple application and once approved you can access up to $25,000 through a Title Pawn Loan, up to $5,000 through an Installment Loan, or up to $500 through a Payday Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. If you're not looking for a loan, we offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! We look forward to meeting you.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:48.000+02:00",
    "country": "US",
    "lat": 32.3276847,
    "lng": -86.25873352,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 334-288-8865",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284597,
        "dateCreated": "2022-04-12T16:41:46.000+02:00",
        "repoKey": "1t2y5IsZq8.jpeg",
        "locationId": 3283526,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283526/1t2y5IsZq8.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283526/medium_1t2y5IsZq8.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283526/thumb_1t2y5IsZq8.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113076680,
        "dateCreated": "2023-06-02T14:34:40.000+02:00",
        "repoKey": "ZKrIjYsVlL.png",
        "locationId": 3283526,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283526/ZKrIjYsVlL.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283526/ZKrIjYsVlL.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283526/thumb_ZKrIjYsVlL.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082297,
        "dateCreated": "2025-04-01T20:40:27.000+02:00",
        "repoKey": "dfv8vxjcg9.png",
        "locationId": 3283526,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283526/dfv8vxjcg9.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283526/medium_dfv8vxjcg9.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283526/thumb_dfv8vxjcg9.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing montgomery",
      "easymoney montgomery",
      "installment loans montgomery",
      "payday loans montgomery",
      "title loans montgomery"
    ],
    "labels": [
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:35.000+01:00",
    "averageRating": 4.2,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 853,
    "dataPoints": 51,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "23325",
    "id": 3283524,
    "dateCreated": "2022-03-08T07:26:36.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "Atlanta Highway",
    "streetNo": "3101",
    "streetAndNumber": "3101 Atlanta Highway",
    "addressExtra": null,
    "zip": "36109",
    "city": "Montgomery",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/montgomery/3101-atlanta-hwy/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "The local team of Loan Experts at the Atlanta HWY location of easymoney in Montgomery, AL can help when you have questions and need quick access to cash or financial services. If approved for a loan, you could receive a Payday Loan up to $500, an Installment Loan for up to $5,000, or up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. We know you're busy and always on the go, so we also offer an array of in-store services so you can stop by and take care of all your money-related needs in one spot. We offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. We work hard to make the process easy.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:48.000+02:00",
    "country": "US",
    "lat": 32.38387524,
    "lng": -86.26500278,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 334-273-0354",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284581,
        "dateCreated": "2022-04-12T16:41:34.000+02:00",
        "repoKey": "huGVFd2Y8M.jpeg",
        "locationId": 3283524,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283524/huGVFd2Y8M.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283524/medium_huGVFd2Y8M.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283524/thumb_huGVFd2Y8M.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113076653,
        "dateCreated": "2023-06-02T14:33:20.000+02:00",
        "repoKey": "vFjKW9SF1N.png",
        "locationId": 3283524,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283524/vFjKW9SF1N.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283524/vFjKW9SF1N.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283524/thumb_vFjKW9SF1N.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082294,
        "dateCreated": "2025-04-01T20:40:27.000+02:00",
        "repoKey": "KP9ZFJ4MAi.png",
        "locationId": 3283524,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283524/KP9ZFJ4MAi.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283524/medium_KP9ZFJ4MAi.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283524/thumb_KP9ZFJ4MAi.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing montgomery",
      "easymoney montgomery",
      "installment loans montgomery",
      "payday loans montgomery",
      "title loans montgomery"
    ],
    "labels": [
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:35.000+01:00",
    "averageRating": 4.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 846,
    "dataPoints": 41,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "22125",
    "id": 3283527,
    "dateCreated": "2022-03-08T07:26:36.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "University Drive",
    "streetNo": "2007",
    "streetAndNumber": "2007 University Drive",
    "addressExtra": null,
    "zip": "35816",
    "city": "Huntsville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/huntsville/2007-university-dr/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "When you need help, easymoney is here for you. Visit the University Drive location in Huntsville, AL to learn about all of our loan and financial services options. Need access to cash? If approved through our quick application process, you can receive a Payday Loan for up to $500, an Installment Loan for up to $5,000, or even a Title Pawn Loan for up to $25,000. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. We also offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. We work hard to make the process easy, and that starts with listening to your concerns, answering your questions, and helping you pick the product that is a best fit for your situation. Stop by today for a quick chat, we love to meet our neighbors!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:47.000+02:00",
    "country": "US",
    "lat": 34.7389762,
    "lng": -86.6020086,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 256-203-7070",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284568,
        "dateCreated": "2022-04-12T16:41:25.000+02:00",
        "repoKey": "ERaPD42mbG.jpeg",
        "locationId": 3283527,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283527/ERaPD42mbG.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283527/medium_ERaPD42mbG.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283527/thumb_ERaPD42mbG.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113076692,
        "dateCreated": "2023-06-02T14:35:24.000+02:00",
        "repoKey": "oSuuQAnAmX.png",
        "locationId": 3283527,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283527/oSuuQAnAmX.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283527/oSuuQAnAmX.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283527/thumb_oSuuQAnAmX.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082309,
        "dateCreated": "2025-04-01T20:40:29.000+02:00",
        "repoKey": "nmWbTb3nAn.png",
        "locationId": 3283527,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283527/nmWbTb3nAn.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283527/medium_nmWbTb3nAn.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283527/thumb_nmWbTb3nAn.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing huntsville",
      "easymoney huntsville",
      "installment loans huntsville",
      "payday loans huntsville",
      "title loans huntsville"
    ],
    "labels": [
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:36.000+01:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 42,
    "listingsBeingUpdated": 10,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 858,
    "dataPoints": 388,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "21925",
    "id": 3283525,
    "dateCreated": "2022-03-08T07:26:36.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "Beltline Road Southwest",
    "streetNo": "1402",
    "streetAndNumber": "1402 Beltline Road Southwest",
    "addressExtra": null,
    "zip": "35601",
    "city": "Decatur",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/decatur/1402-beltline-rd-southwest/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Stop by the easymoney store on Beltline Rd in Decatur, AL to learn how our local team of Loan Experts can help you access cash or other in-store services today! If you're approved (don't worry, the approval process is simple) you can access up to $500 through a Payday Loan, $5,000 through an Installment Loan, or $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. Don't need a loan? We also offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! Our team works hard to help all our neighbors when extra cash or financial services are needed, so don't hesitate to reach out with questions. Pop by the store today! We work hard to make the process easy.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:48.000+02:00",
    "country": "US",
    "lat": 34.5636098,
    "lng": -87.0084271,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 256-274-8166",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284612,
        "dateCreated": "2022-04-12T16:41:55.000+02:00",
        "repoKey": "uefr4bVgYo.jpeg",
        "locationId": 3283525,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283525/uefr4bVgYo.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283525/medium_uefr4bVgYo.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283525/thumb_uefr4bVgYo.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113076674,
        "dateCreated": "2023-06-02T14:33:58.000+02:00",
        "repoKey": "xqtXioqAHO.png",
        "locationId": 3283525,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283525/xqtXioqAHO.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283525/xqtXioqAHO.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283525/thumb_xqtXioqAHO.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082314,
        "dateCreated": "2025-04-01T20:40:30.000+02:00",
        "repoKey": "PeewQST5V8.png",
        "locationId": 3283525,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283525/PeewQST5V8.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283525/medium_PeewQST5V8.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283525/thumb_PeewQST5V8.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing decatur",
      "easymoney decatur",
      "installment loans decatur",
      "payday loans decatur",
      "title loans decatur"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:35.000+01:00",
    "averageRating": 4.2,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 850,
    "dataPoints": 54,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "26525",
    "id": 3283532,
    "dateCreated": "2022-03-08T07:26:37.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "SpringHill Avenue",
    "streetNo": "2950",
    "streetAndNumber": "2950 SpringHill Avenue",
    "addressExtra": null,
    "zip": "36607",
    "city": "Mobile",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/mobile/2950-springhill-ave/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "If you are looking for a team of Loan Experts to help you navigate your choices and need quick access to cash, look no further than the easymoney store on Spring Hill Ave in Mobile, AL. Our team has answers to your questions and can help you get the ball rolling when you need a loan or other quick financial services such as check cashing, wire transfers, money orders, bill pay, or Green Dot Visa® Debit Cards! Once approved you can access up to $500 through a Payday Loan, up to $5,000 through an Installment Loan, or up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. We work hard to make the process easy. So, stop by today to learn more!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:47.000+02:00",
    "country": "US",
    "lat": 30.69972355,
    "lng": -88.11012133,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 251-476-2978",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284611,
        "dateCreated": "2022-04-12T16:41:54.000+02:00",
        "repoKey": "YvQ72jp7YJ.jpeg",
        "locationId": 3283532,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283532/YvQ72jp7YJ.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283532/medium_YvQ72jp7YJ.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283532/thumb_YvQ72jp7YJ.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113064835,
        "dateCreated": "2023-06-01T20:50:32.000+02:00",
        "repoKey": "GLmynLDRKF.png",
        "locationId": 3283532,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283532/GLmynLDRKF.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283532/GLmynLDRKF.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283532/thumb_GLmynLDRKF.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082280,
        "dateCreated": "2025-04-01T20:40:25.000+02:00",
        "repoKey": "FGfPjZqZWJ.png",
        "locationId": 3283532,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283532/FGfPjZqZWJ.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283532/medium_FGfPjZqZWJ.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283532/thumb_FGfPjZqZWJ.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing mobile",
      "easymoney mobile",
      "installment loans mobile",
      "payday loans mobile",
      "title loans mobile"
    ],
    "labels": [
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:37.000+01:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 869,
    "dataPoints": 80,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "21025",
    "id": 3283531,
    "dateCreated": "2022-03-08T07:26:37.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "23rd Street South",
    "streetNo": "728",
    "streetAndNumber": "728 23rd Street South",
    "addressExtra": null,
    "zip": "35233",
    "city": "Birmingham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/birmingham/728-23rd-st-south/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "As your go-to neighborhood lender, easymoney offers convenience and customer service you can count on. In addition to our local services like check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards at our South 23rd St location in Birmingham, AL, you can connect with a Loan Expert and apply for installment loans, payday loans, and title loans. If approved, you could access up to $500 through a Payday Loan, up to $5,000 through an Installment Loan, or even up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. Our team works hard to meet your needs and make the process easy, so stop by easymoney to learn more and to get the ball rolling! We work hard to make the process easy.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:47.000+02:00",
    "country": "US",
    "lat": 33.50689,
    "lng": -86.79539,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-769-3800",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284584,
        "dateCreated": "2022-04-12T16:41:36.000+02:00",
        "repoKey": "hmdHUOhctO.jpeg",
        "locationId": 3283531,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283531/hmdHUOhctO.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283531/medium_hmdHUOhctO.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283531/thumb_hmdHUOhctO.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113064805,
        "dateCreated": "2023-06-01T20:47:33.000+02:00",
        "repoKey": "a8ZPEEcevq.png",
        "locationId": 3283531,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283531/a8ZPEEcevq.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283531/a8ZPEEcevq.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283531/thumb_a8ZPEEcevq.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082289,
        "dateCreated": "2025-04-01T20:40:26.000+02:00",
        "repoKey": "qEPDJjWZfi.png",
        "locationId": 3283531,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283531/qEPDJjWZfi.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283531/medium_qEPDJjWZfi.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283531/thumb_qEPDJjWZfi.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing birmingham",
      "easymoney birmingham",
      "installment loans birmingham",
      "payday loans birmingham",
      "title loans birmingham"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:36.000+01:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 872,
    "dataPoints": 111,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "24286",
    "id": 3283530,
    "dateCreated": "2022-03-08T07:26:37.000+01:00",
    "lastUpdated": "2025-04-04T01:30:11.000+02:00",
    "name": "Easy Money",
    "street": "South Riverside Drive",
    "streetNo": "602A",
    "streetAndNumber": "602A South Riverside Drive",
    "addressExtra": null,
    "zip": "37040",
    "city": "Clarksville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/tn/clarksville/602a-south-riverside-dr/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Unexpected emergencies crop up from time to time, we get it. That's why easymoney makes access to the cash you need, fast and easy. We have two easymoney cash centers in Clarksville, TN including our conveniently located Riverside Drive South location! You could qualify for a Payday Loan up to $425. Additionally, we offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. Drop on in, our Loan Experts are eager to meet their neighbors and walk you through the whole process!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:47.000+02:00",
    "country": "US",
    "lat": 36.52025178,
    "lng": -87.36356447,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 931-542-4811",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284580,
        "dateCreated": "2022-04-12T16:41:34.000+02:00",
        "repoKey": "QXbvi25It1.jpeg",
        "locationId": 3283530,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283530/QXbvi25It1.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283530/medium_QXbvi25It1.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283530/thumb_QXbvi25It1.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113064811,
        "dateCreated": "2023-06-01T20:48:16.000+02:00",
        "repoKey": "lBML2ycHjc.png",
        "locationId": 3283530,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283530/lBML2ycHjc.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283530/lBML2ycHjc.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283530/thumb_lBML2ycHjc.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082310,
        "dateCreated": "2025-04-01T20:40:30.000+02:00",
        "repoKey": "UMWKAd7fPH.png",
        "locationId": 3283530,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283530/UMWKAd7fPH.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283530/medium_UMWKAd7fPH.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283530/thumb_UMWKAd7fPH.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing clarksville",
      "easymoney clarksville",
      "line of credit clarksville",
      "payday loans clarksville",
      "title loans clarksville"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "EasyMoneyTN",
        "adminOnly": true
      },
      {
        "name": "Tennessee",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:36.000+01:00",
    "averageRating": 4.4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 866,
    "dataPoints": 52,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "TN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "20925",
    "id": 3283534,
    "dateCreated": "2022-03-08T07:26:38.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "1st Avenue North",
    "streetNo": "6400",
    "streetAndNumber": "6400 1st Avenue North",
    "addressExtra": null,
    "zip": "35212",
    "city": "Birmingham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/birmingham/6400-1st-ave-north/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Your Birmingham, AL neighborhood easymoney store on First Avenue N is standing by and ready to help you obtain needed funds quickly and efficiently when needed. We offer a convenient location, knowledgeable team members, and services like check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. Our loan types include Payday Loans, Installment Loans, and Title Pawn Loans. If approved for a loan, you could access up to $500 through a Payday Loan, up to $5,000 through an Installment Loan, or even up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. We know that when you need cash fast, convenience and great customer service are important. Stop by easymoney today to learn more. We are a part of the community and work hard to serve our neighbors with loan options and financial services made easy.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:47.000+02:00",
    "country": "US",
    "lat": 33.5481292,
    "lng": -86.74367969,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-591-0800",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284592,
        "dateCreated": "2022-04-12T16:41:41.000+02:00",
        "repoKey": "e0yG2h5oio.jpeg",
        "locationId": 3283534,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283534/e0yG2h5oio.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283534/medium_e0yG2h5oio.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283534/thumb_e0yG2h5oio.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113064857,
        "dateCreated": "2023-06-01T20:52:09.000+02:00",
        "repoKey": "igaOBdN3UI.png",
        "locationId": 3283534,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283534/igaOBdN3UI.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283534/igaOBdN3UI.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283534/thumb_igaOBdN3UI.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082274,
        "dateCreated": "2025-04-01T20:40:24.000+02:00",
        "repoKey": "8GyQIYNInW.png",
        "locationId": 3283534,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283534/8GyQIYNInW.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283534/medium_8GyQIYNInW.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283534/thumb_8GyQIYNInW.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing birmingham",
      "easymoney birmingham",
      "installment loans birmingham",
      "payday loans birmingham",
      "title loans birmingham"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:38.000+01:00",
    "averageRating": 3.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 875,
    "dataPoints": 29,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "23125",
    "id": 3283533,
    "dateCreated": "2022-03-08T07:26:38.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "Cahaba Valley Road",
    "streetNo": "460",
    "streetAndNumber": "460 Cahaba Valley Road",
    "addressExtra": null,
    "zip": "35124",
    "city": "Pelham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/pelham/460-cahaba-valley-rd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "At easymoney, we think solutions should be easy. Stop by the Cahaba Valley Rd location of easymoney in Pelham, AL when you need quick access to cash through a loan or any of our other in-store services such as checking cashing, wire transfers, money orders, bill pay, or Green Dot Visa® Debit Cards! We offer loans up to $500 through our Payday Loan option, up to $5,000 through our Installment Loan option, and up to $25,000 through our Title Pawn Loan option. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. We work hard to make the process easy, so pop by and meet your neighbors! We're here to help.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:47.000+02:00",
    "country": "US",
    "lat": 33.33406517,
    "lng": -86.78398468,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-552-0010",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284615,
        "dateCreated": "2022-04-12T16:41:58.000+02:00",
        "repoKey": "4iRlfAb0c2.jpeg",
        "locationId": 3283533,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283533/4iRlfAb0c2.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283533/medium_4iRlfAb0c2.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283533/thumb_4iRlfAb0c2.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113064849,
        "dateCreated": "2023-06-01T20:51:25.000+02:00",
        "repoKey": "56kjj4NjNG.png",
        "locationId": 3283533,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283533/56kjj4NjNG.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283533/56kjj4NjNG.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283533/thumb_56kjj4NjNG.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082302,
        "dateCreated": "2025-04-01T20:40:28.000+02:00",
        "repoKey": "c203b8LCdm.png",
        "locationId": 3283533,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283533/c203b8LCdm.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283533/medium_c203b8LCdm.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283533/thumb_c203b8LCdm.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing pelham",
      "easymoney pelham",
      "installment loans pelham",
      "payday loans pelham",
      "title loans pelham"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:38.000+01:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 875,
    "dataPoints": 28,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "23025",
    "id": 3283538,
    "dateCreated": "2022-03-08T07:26:39.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "West Fairview Avenue",
    "streetNo": "20",
    "streetAndNumber": "20 West Fairview Avenue",
    "addressExtra": null,
    "zip": "36105",
    "city": "Montgomery",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/montgomery/20-west-fairview-ave/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Looking for loan solutions? The team at easymoney on Fairview Ave in Montgomery, AL can help. We offer Payday Loans up to $500, Installment Loans up to $5,000, and even Title Pawn Loans up to $25,000 to qualified applicants. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. If you're not needing a loan at this time, we also offer an array of in-store services that will help you get more checked off your to do list at once and on your way quickly. We know you're busy! We offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. Stop by today to learn more. We work hard to make the process easy, and we look forward to meeting you! Helping our neighbors is always our goal.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:46.000+02:00",
    "country": "US",
    "lat": 32.35229377,
    "lng": -86.30942073,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 334-558-9000",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284609,
        "dateCreated": "2022-04-12T16:41:53.000+02:00",
        "repoKey": "XKog1oGwXe.jpeg",
        "locationId": 3283538,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283538/XKog1oGwXe.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283538/medium_XKog1oGwXe.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283538/thumb_XKog1oGwXe.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113064962,
        "dateCreated": "2023-06-01T21:01:22.000+02:00",
        "repoKey": "IhnSwF5oWD.png",
        "locationId": 3283538,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283538/IhnSwF5oWD.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283538/IhnSwF5oWD.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283538/thumb_IhnSwF5oWD.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082287,
        "dateCreated": "2025-04-01T20:40:26.000+02:00",
        "repoKey": "FlAV46mgRi.png",
        "locationId": 3283538,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283538/FlAV46mgRi.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283538/medium_FlAV46mgRi.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283538/thumb_FlAV46mgRi.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing montgomery",
      "easymoney montgomery",
      "installment loans montgomery",
      "payday loans montgomery",
      "title loans montgomery"
    ],
    "labels": [
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:38.000+01:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 878,
    "dataPoints": 29,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "25925",
    "id": 3283535,
    "dateCreated": "2022-03-08T07:26:39.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "Forestdale Boulevard",
    "streetNo": "1605",
    "streetAndNumber": "1605 Forestdale Boulevard",
    "addressExtra": null,
    "zip": "35214",
    "city": "Forestdale",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/forestdale/1605-forestdale-blvd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Stop by your local easymoney store on Forestdale Blvd in Forestdale, AL and connect with our team of local Loan Experts. We work hard to make the process easy for you when you need access to cash or other financial services in a convenient, neighborhood location. We offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. We also have Payday Loans up to $500, Installment Loans up to $5,000 and Title Pawn Loans up to $25,000 which you can access quickly if approved. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. When you need a little help, easymoney is here to assist you. Stop by today to learn more!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:47.000+02:00",
    "country": "US",
    "lat": 33.56898511,
    "lng": -86.89822212,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-639-5858",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284622,
        "dateCreated": "2022-04-12T16:42:01.000+02:00",
        "repoKey": "K6OBDK0Xr1.jpeg",
        "locationId": 3283535,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283535/K6OBDK0Xr1.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283535/medium_K6OBDK0Xr1.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283535/thumb_K6OBDK0Xr1.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113064872,
        "dateCreated": "2023-06-01T20:53:43.000+02:00",
        "repoKey": "7pF8YYP1rm.png",
        "locationId": 3283535,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283535/7pF8YYP1rm.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283535/7pF8YYP1rm.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283535/thumb_7pF8YYP1rm.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082288,
        "dateCreated": "2025-04-01T20:40:26.000+02:00",
        "repoKey": "y9JFB4Ziml.png",
        "locationId": 3283535,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283535/y9JFB4Ziml.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283535/medium_y9JFB4Ziml.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283535/thumb_y9JFB4Ziml.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing forestdale",
      "easymoney forestdale",
      "installment loans forestdale",
      "payday loans forestdale",
      "title loans forestdale"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:38.000+01:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 289,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "20825",
    "id": 3283537,
    "dateCreated": "2022-03-08T07:26:39.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "Montclair Road",
    "streetNo": "1552",
    "streetAndNumber": "1552 Montclair Road",
    "addressExtra": null,
    "zip": "35210",
    "city": "Birmingham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/birmingham/1552-montclair-rd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "The Montclair Rd location of easymoney in Birmingham, AL is at your service and our team will work hard to make the process of accessing cash or other financial services easy. We offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. We also offer several loan options. If you're approved, you can receive up to $500 through a Payday Loan, $5,000 with an Installment Loan, or $25,000 with a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. Our team of Loan Experts want to make the process as simple as possible, and they are available to answer any questions you may have to make the process easy.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:47.000+02:00",
    "country": "US",
    "lat": 33.52503,
    "lng": -86.72385,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-956-2424",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284604,
        "dateCreated": "2022-04-12T16:41:50.000+02:00",
        "repoKey": "bmovUBfAWH.jpeg",
        "locationId": 3283537,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283537/bmovUBfAWH.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283537/medium_bmovUBfAWH.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283537/thumb_bmovUBfAWH.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113064953,
        "dateCreated": "2023-06-01T21:00:29.000+02:00",
        "repoKey": "D9NVxVCabZ.png",
        "locationId": 3283537,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283537/D9NVxVCabZ.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283537/D9NVxVCabZ.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283537/thumb_D9NVxVCabZ.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082293,
        "dateCreated": "2025-04-01T20:40:27.000+02:00",
        "repoKey": "X5NrSyRDjU.png",
        "locationId": 3283537,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283537/X5NrSyRDjU.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283537/medium_X5NrSyRDjU.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283537/thumb_X5NrSyRDjU.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing birmingham",
      "easymoney birmingham",
      "installment loans birmingham",
      "payday loans birmingham",
      "title loans birmingham"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Alabama",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:38.000+01:00",
    "averageRating": 4.4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 872,
    "dataPoints": 92,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "25825",
    "id": 3283539,
    "dateCreated": "2022-03-08T07:26:39.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "Bankhead Highway West",
    "streetNo": "1001",
    "streetAndNumber": "1001 Bankhead Highway West",
    "addressExtra": null,
    "zip": "35204",
    "city": "Birmingham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/birmingham/1001-bankhead-hwy-west/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Need cash in a flash? Pop by the Bankhead HWY location of easymoney in Birmingham, AL and connect with a local Loan Expert to learn how easy the process can be. We offer Title Loans, Payday Loans, and Installment loans as well as an array of financial services. If you're approved for a loan, you could access up to $500 through a Payday Loan, up to $5,000 through an Installment Loan, or even up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. We also offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. Our goal is to make the process easy and to have you in and out in a timely fashion so you can keep your day rolling and get everything done on your to-do list.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:46.000+02:00",
    "country": "US",
    "lat": 33.53112722,
    "lng": -86.85375312,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-397-1200",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284610,
        "dateCreated": "2022-04-12T16:41:53.000+02:00",
        "repoKey": "iYPhVT3qDj.jpeg",
        "locationId": 3283539,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283539/iYPhVT3qDj.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283539/medium_iYPhVT3qDj.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283539/thumb_iYPhVT3qDj.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113077028,
        "dateCreated": "2023-06-02T14:51:44.000+02:00",
        "repoKey": "xOFSmMdPWk.png",
        "locationId": 3283539,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283539/xOFSmMdPWk.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283539/xOFSmMdPWk.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283539/thumb_xOFSmMdPWk.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082306,
        "dateCreated": "2025-04-01T20:40:29.000+02:00",
        "repoKey": "RaZGlmHmxx.png",
        "locationId": 3283539,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283539/RaZGlmHmxx.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283539/medium_RaZGlmHmxx.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283539/thumb_RaZGlmHmxx.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing birmingham",
      "easymoney birmingham",
      "installment loans birmingham",
      "payday loans birmingham",
      "title loans birmingham"
    ],
    "labels": [
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:38.000+01:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 877,
    "dataPoints": 58,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "20725",
    "id": 3283541,
    "dateCreated": "2022-03-08T07:26:40.000+01:00",
    "lastUpdated": "2025-04-04T01:30:13.000+02:00",
    "name": "Easy Money",
    "street": "Green Springs Highway",
    "streetNo": "2168",
    "streetAndNumber": "2168 Green Springs Highway",
    "addressExtra": null,
    "zip": "35205",
    "city": "Birmingham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/birmingham/2168-green-springs-hwy/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "The team at easymoney on Green Springs Hwy in Birmingham, AL are standing by and ready to help you with quick, simple access to cash and financial services when you need them. If you need a loan, we have options that may be a fit! If you're approved, you can access up to $500 through a Payday Loan, up to $5,000 through an Installment Loan, or up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. Don't need a loan at this time? We also offer an array of financial services in store including check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! So, stop by your neighborhood easymoney store to learn more. We're working hard to make it easy on you.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:46.000+02:00",
    "country": "US",
    "lat": 33.48177,
    "lng": -86.824174,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-942-0001",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284608,
        "dateCreated": "2022-04-12T16:41:52.000+02:00",
        "repoKey": "1j7HPQ8evh.jpeg",
        "locationId": 3283541,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283541/1j7HPQ8evh.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283541/medium_1j7HPQ8evh.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283541/thumb_1j7HPQ8evh.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113077008,
        "dateCreated": "2023-06-02T14:51:13.000+02:00",
        "repoKey": "ayHib6ORMT.png",
        "locationId": 3283541,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283541/ayHib6ORMT.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283541/ayHib6ORMT.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283541/thumb_ayHib6ORMT.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082285,
        "dateCreated": "2025-04-01T20:40:25.000+02:00",
        "repoKey": "NxMCMxjcHY.png",
        "locationId": 3283541,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283541/NxMCMxjcHY.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283541/medium_NxMCMxjcHY.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283541/thumb_NxMCMxjcHY.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing birmingham",
      "easymoney birmingham",
      "installment loans birmingham",
      "payday loans birmingham",
      "title loans birmingham"
    ],
    "labels": [
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:40.000+01:00",
    "averageRating": 4.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 870,
    "dataPoints": 150,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "25625",
    "id": 3283542,
    "dateCreated": "2022-03-08T07:26:40.000+01:00",
    "lastUpdated": "2025-04-03T00:29:46.000+02:00",
    "name": "Easy Money",
    "street": "McFarland Boulevard East",
    "streetNo": "2925",
    "streetAndNumber": "2925 McFarland Boulevard East",
    "addressExtra": null,
    "zip": "35404",
    "city": "Tuscaloosa",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/tuscaloosa/2925-mcfarland-blvd-east/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "When you need access to cash, you need convenience and ease. At easymoney, we're working hard to make it easy. Stop by the Tuscaloosa, AL easymoney store on McFarland Blvd and let our Loan Experts go over options with you. If you're approved through our easy loan process, you could access up to $500 through a Payday Loan, up to $5,000 through an Installment Loan, or even up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. We also offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. Stop by today. We love meeting our neighbors!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:46.000+02:00",
    "country": "US",
    "lat": 33.18269,
    "lng": -87.525362,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-366-0140",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284613,
        "dateCreated": "2022-04-12T16:41:56.000+02:00",
        "repoKey": "cronreTtK4.jpeg",
        "locationId": 3283542,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283542/cronreTtK4.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283542/medium_cronreTtK4.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283542/thumb_cronreTtK4.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113076992,
        "dateCreated": "2023-06-02T14:50:33.000+02:00",
        "repoKey": "LJb9d0Cjy8.png",
        "locationId": 3283542,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283542/LJb9d0Cjy8.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283542/LJb9d0Cjy8.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283542/thumb_LJb9d0Cjy8.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082304,
        "dateCreated": "2025-04-01T20:40:29.000+02:00",
        "repoKey": "orZAZknVJW.png",
        "locationId": 3283542,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283542/orZAZknVJW.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283542/medium_orZAZknVJW.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283542/thumb_orZAZknVJW.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing tuscaloosa",
      "easymoney tuscaloosa",
      "installment loans tuscaloosa",
      "payday loans tuscaloosa",
      "title loans tuscaloosa"
    ],
    "labels": [
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:39.000+01:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 879,
    "dataPoints": 122,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "21725",
    "id": 3283543,
    "dateCreated": "2022-03-08T07:26:41.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "2nd Avenue East",
    "streetNo": "922",
    "streetAndNumber": "922 2nd Avenue East",
    "addressExtra": null,
    "zip": "35121",
    "city": "Oneonta",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/oneonta/922-2nd-ave-east/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Access to cash can feel hard to come by, but not when you choose to work with the easymoney location on 2nd Avenue in Oneonta, AL. Our team of dedicated Loan Experts can help you find solutions to life's financial hurdles. We offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. We also have Payday Loans up to $500, Installment Loans up to $5,000 and Title Pawn Loans up to $25,000 which you can access quickly if approved. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. When you need us, easymoney is here to assist you. Stop by today to learn more!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:46.000+02:00",
    "country": "US",
    "lat": 33.95564818,
    "lng": -86.46589547,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-660-2400",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284621,
        "dateCreated": "2022-04-12T16:42:00.000+02:00",
        "repoKey": "1hLQ46kwZO.jpeg",
        "locationId": 3283543,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283543/1hLQ46kwZO.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283543/medium_1hLQ46kwZO.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283543/thumb_1hLQ46kwZO.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113076967,
        "dateCreated": "2023-06-02T14:49:58.000+02:00",
        "repoKey": "LmqM1fQ8pW.png",
        "locationId": 3283543,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283543/LmqM1fQ8pW.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283543/LmqM1fQ8pW.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283543/thumb_LmqM1fQ8pW.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082312,
        "dateCreated": "2025-04-01T20:40:30.000+02:00",
        "repoKey": "GTcj4KXE0v.png",
        "locationId": 3283543,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283543/GTcj4KXE0v.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283543/medium_GTcj4KXE0v.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283543/thumb_GTcj4KXE0v.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing oneonta",
      "easymoney oneonta",
      "installment loans oneonta",
      "payday loans oneonta",
      "title loans oneonta"
    ],
    "labels": [
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Alabama",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:40.000+01:00",
    "averageRating": 4.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 862,
    "dataPoints": 51,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "22625",
    "id": 3283544,
    "dateCreated": "2022-03-08T07:26:41.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "Montgomery Highway",
    "streetNo": "1678",
    "streetAndNumber": "1678 Montgomery Highway",
    "addressExtra": "Suite 105",
    "zip": "35216",
    "city": "Birmingham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/birmingham/1678-montgomery-hwy/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "When you need access to cash and want to visit a friendly, neighborhood team of experts for assistance, look no further than the easymoney team on Montgomery HWY in Birmingham, AL. Our Loan Experts are available to answer any questions you may have and will work hard to find solutions to your financial situation. We have multiple loan types available that may be a fit for your specific situation if approved including Payday Loans (up to $500), Installment Loans (up to $5,000), and Title Pawn Loans (up to $25,000). You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. We also offer multiple financial services in store to meet your needs quickly and easily such as: check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! Pop by your local store to learn more and get the ball rolling. We work hard to make it easy on you.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:46.000+02:00",
    "country": "US",
    "lat": 33.391623,
    "lng": -86.807277,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-413-4460",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284603,
        "dateCreated": "2022-04-12T16:41:48.000+02:00",
        "repoKey": "gALXknkAIR.jpeg",
        "locationId": 3283544,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283544/gALXknkAIR.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283544/medium_gALXknkAIR.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283544/thumb_gALXknkAIR.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113076911,
        "dateCreated": "2023-06-02T14:49:29.000+02:00",
        "repoKey": "cW9SpIsfg6.png",
        "locationId": 3283544,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283544/cW9SpIsfg6.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283544/cW9SpIsfg6.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283544/thumb_cW9SpIsfg6.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082307,
        "dateCreated": "2025-04-01T20:40:29.000+02:00",
        "repoKey": "AnicoDGJZs.png",
        "locationId": 3283544,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283544/AnicoDGJZs.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283544/medium_AnicoDGJZs.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283544/thumb_AnicoDGJZs.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing birmingham",
      "easymoney birmingham",
      "installment loans birmingham",
      "payday loans birmingham",
      "title loans birmingham"
    ],
    "labels": [
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:41.000+01:00",
    "averageRating": 4.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 893,
    "dataPoints": 109,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "25725",
    "id": 3283547,
    "dateCreated": "2022-03-08T07:26:42.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "Midfield Alley",
    "streetNo": "210B",
    "streetAndNumber": "210B Midfield Alley",
    "addressExtra": null,
    "zip": "35228",
    "city": "Birmingham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/birmingham/210b-midfield-alley/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Need cash quickly and conveniently? The Loan Experts at easymoney on Midfield Alley in Birmingham, AL are standing by and ready to help you with the process. We have a range of financial services available in store including check cashing, money orders, bill pay, wire transfers, and Green Dot Visa® Debit Cards. We also offer Payday Loans up to $500 if approved, Title Pawn Loans up to $25,000, and Installment Loans up to $5,000. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. All loans are subject to approval and site-specific requirements, check with a store team member for details. We know that your time is valuable and convenience is key. That's why we work hard to make it easy.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:46.000+02:00",
    "country": "US",
    "lat": 33.46219216,
    "lng": -86.91018407,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-923-3762",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284607,
        "dateCreated": "2022-04-12T16:41:52.000+02:00",
        "repoKey": "nkqwCqkwa2.jpeg",
        "locationId": 3283547,
        "description": "",
        "identifier": "6f24d67a-c6ee-4ca7-9980-b4f4ece70696",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283547/nkqwCqkwa2.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283547/medium_nkqwCqkwa2.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283547/thumb_nkqwCqkwa2.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/b9a2b436-8099-4a24-8b77-b268a8514b89/easymoneystore.jpg"
      },
      {
        "id": 113064743,
        "dateCreated": "2023-06-01T20:40:05.000+02:00",
        "repoKey": "fl47tNS97Q.png",
        "locationId": 3283547,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283547/fl47tNS97Q.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283547/fl47tNS97Q.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283547/thumb_fl47tNS97Q.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082281,
        "dateCreated": "2025-04-01T20:40:25.000+02:00",
        "repoKey": "b56HeOG3U6.png",
        "locationId": 3283547,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283547/b56HeOG3U6.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283547/medium_b56HeOG3U6.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283547/thumb_b56HeOG3U6.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing birmingham",
      "easymoney birmingham",
      "installment loans birmingham",
      "payday loans birmingham",
      "title loans birmingham"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:41.000+01:00",
    "averageRating": 4.4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 855,
    "dataPoints": 137,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Chicago"
  },
  {
    "identifier": "22825",
    "id": 3283548,
    "dateCreated": "2022-03-08T07:26:42.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "U.S. Highway 280",
    "streetNo": "4673",
    "streetAndNumber": "4673 U.S. Highway 280",
    "addressExtra": "Suite C",
    "zip": "35243",
    "city": "Birmingham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/birmingham/4673-u.s.-hwy-280/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "The easymoney local Loan Experts at the Hwy 280 East location in Birmingham, AL are eager to help and standing by ready to answer any questions you may have about our loan options and financial services. If approved for a loan, you could receive a Payday Loan up to $500, an Installment Loan for up to $5,000, or up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. We know you're busy and always on the go, so we also offer an array of in-store services so you can stop by and take care of all your money-related needs in one spot. We offer check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards. Your convenience is our priority, so rest assured our team will work hard to make the process as easy as possible for you when you arrive!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:46.000+02:00",
    "country": "US",
    "lat": 33.42468346,
    "lng": -86.70132596,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-437-1515",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284582,
        "dateCreated": "2022-04-12T16:41:36.000+02:00",
        "repoKey": "k3M4ypaNmc.jpeg",
        "locationId": 3283548,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283548/k3M4ypaNmc.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283548/medium_k3M4ypaNmc.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283548/thumb_k3M4ypaNmc.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113064741,
        "dateCreated": "2023-06-01T20:39:19.000+02:00",
        "repoKey": "xqFxoqoXfq.png",
        "locationId": 3283548,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283548/xqFxoqoXfq.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283548/xqFxoqoXfq.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283548/thumb_xqFxoqoXfq.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082282,
        "dateCreated": "2025-04-01T20:40:25.000+02:00",
        "repoKey": "870JUiDOEH.png",
        "locationId": 3283548,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283548/870JUiDOEH.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283548/medium_870JUiDOEH.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283548/thumb_870JUiDOEH.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing birmingham",
      "easymoney birmingham",
      "installment loans birmingham",
      "payday loans birmingham",
      "title loans birmingham"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:41.000+01:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 41,
    "listingsBeingUpdated": 11,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 898,
    "dataPoints": 111,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "25525",
    "id": 3283546,
    "dateCreated": "2022-03-08T07:26:42.000+01:00",
    "lastUpdated": "2025-04-04T01:30:13.000+02:00",
    "name": "Easy Money",
    "street": "Tyler Drive",
    "streetNo": "3032",
    "streetAndNumber": "3032 Tyler Drive",
    "addressExtra": null,
    "zip": "35476",
    "city": "Northport",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/northport/3032-tyler-dr/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "When you need a little extra help and access to cash, easymoney is here for you. The team of Loan Experts at the Northport, AL location on Tyler Dr look forward to meeting you, neighbor, and helping you find the right solution for your unique situation. Looking for a loan? We offer Payday Loans up to $500, Installment Loans up to $5,000, and even Title Pawn Loans up to $25,000 to qualified applicants. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. Your neighborhood easymoney store also offers check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! We work hard to make it easy for you to get the services and loan options that you need.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:46.000+02:00",
    "country": "US",
    "lat": 33.2375539,
    "lng": -87.57394475,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-330-0913",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284586,
        "dateCreated": "2022-04-12T16:41:38.000+02:00",
        "repoKey": "punTwgp0gJ.jpeg",
        "locationId": 3283546,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283546/punTwgp0gJ.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283546/medium_punTwgp0gJ.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283546/thumb_punTwgp0gJ.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113064754,
        "dateCreated": "2023-06-01T20:40:39.000+02:00",
        "repoKey": "xNOzlhxsNZ.png",
        "locationId": 3283546,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283546/xNOzlhxsNZ.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283546/xNOzlhxsNZ.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283546/thumb_xNOzlhxsNZ.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082284,
        "dateCreated": "2025-04-01T20:40:25.000+02:00",
        "repoKey": "5Ad5SbEJFi.png",
        "locationId": 3283546,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283546/5Ad5SbEJFi.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283546/medium_5Ad5SbEJFi.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283546/thumb_5Ad5SbEJFi.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing northport",
      "easymoney northport",
      "installment loans northport",
      "payday loans northport",
      "title loans northport"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:41.000+01:00",
    "averageRating": 4.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 870,
    "dataPoints": 74,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "20025",
    "id": 3283545,
    "dateCreated": "2022-03-08T07:26:42.000+01:00",
    "lastUpdated": "2025-04-04T01:30:13.000+02:00",
    "name": "Easy Money",
    "street": "Parkway East",
    "streetNo": "9420",
    "streetAndNumber": "9420 Parkway East",
    "addressExtra": null,
    "zip": "35215",
    "city": "Birmingham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/birmingham/9420-pkwy-east/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "The local Loan Experts at easymoney on Parkway East in Birmingham, AL can walk you through the loan process simply and easily. If you need access to additional cash for any reason, let easymoney assist you. Once you've completed our application process and received the green light, you can access up to $500 through a Payday Loan, up to $5,000 through an Installment Loan, or up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. If you don't need a loan at this time, we also offer multiple in-store services to meet your needs. Your neighborhood easymoney store offers check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! We work hard to make it easy for you to access the services and loan options that you need.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:46.000+02:00",
    "country": "US",
    "lat": 33.59287267,
    "lng": -86.69629921,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-413-4478",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139082300,
        "dateCreated": "2025-04-01T20:40:28.000+02:00",
        "repoKey": "w6npKitY9T.png",
        "locationId": 3283545,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283545/w6npKitY9T.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283545/medium_w6npKitY9T.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283545/thumb_w6npKitY9T.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      },
      {
        "id": 95284589,
        "dateCreated": "2022-04-12T16:41:40.000+02:00",
        "repoKey": "bZ8wl2Kokv.jpeg",
        "locationId": 3283545,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283545/bZ8wl2Kokv.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283545/medium_bZ8wl2Kokv.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283545/thumb_bZ8wl2Kokv.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      }
    ],
    "keywords": [
      "check cashing birmingham",
      "easymoney birmingham",
      "installment loans birmingham",
      "payday loans birmingham",
      "title loans birmingham"
    ],
    "labels": [
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:41.000+01:00",
    "averageRating": 3.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 42,
    "listingsBeingUpdated": 10,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 126,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "identifier": "25425",
    "id": 3283550,
    "dateCreated": "2022-03-08T07:26:43.000+01:00",
    "lastUpdated": "2025-04-04T01:30:12.000+02:00",
    "name": "Easy Money",
    "street": "Bessemer Road",
    "streetNo": "2145",
    "streetAndNumber": "2145 Bessemer Road",
    "addressExtra": null,
    "zip": "35208",
    "city": "Birmingham",
    "cellphone": null,
    "fax": null,
    "website": "https://www.easymoneycashcenters.com/store/al/birmingham/2145-bessemer-rd/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "Looking for an alternative cash solution? Want to work with a trusted, local, neighborhood team? Visit the Bessemer Rd easymoney location in Birmingham, AL and find out how our team can help. We have a team of Loan Experts standing by and ready to answer any questions you may have which can make the process go smoothly. Interested in a Payday Loan? You could get up to $500 if approved. Need a little more cash than that? Perhaps an Installment Loan for up to $5,000 would be the right option for you. If you need a significantly larger amount, you can receive up to $25,000 through a Title Pawn Loan. You'll need to bring your vehicle and a clear title for review during the Title Pawn Loan approval process. Motorcycle Title Pawn Loans can be approved for up to $5,000. If you don't need a loan, we also offer an array of in-store services to meet your needs including check cashing, wire transfers, money orders, bill pay, and Green Dot Visa® Debit Cards! Stop by today for more information.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:45.000+02:00",
    "country": "US",
    "lat": 33.49429421,
    "lng": -86.87950659,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 205-781-9171",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 95284602,
        "dateCreated": "2022-04-12T16:41:47.000+02:00",
        "repoKey": "f42htKa3hn.jpeg",
        "locationId": 3283550,
        "description": "",
        "identifier": "b9a2b436-8099-4a24-8b77-b268a8514b89",
        "main": false,
        "logo": false,
        "type": "EXTERIOR",
        "url": "/uploads/userpics/3283550/f42htKa3hn.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283550/medium_f42htKa3hn.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283550/thumb_f42htKa3hn.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://prod-media-api-service-locations.s3.amazonaws.com/5ff239f6957b485d6945bc81/6f24d67a-c6ee-4ca7-9980-b4f4ece70696/easymoneystore.jpg"
      },
      {
        "id": 113064729,
        "dateCreated": "2023-06-01T20:37:58.000+02:00",
        "repoKey": "Lc80JsRPoW.png",
        "locationId": 3283550,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3283550/Lc80JsRPoW.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283550/Lc80JsRPoW.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283550/thumb_Lc80JsRPoW.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 139082283,
        "dateCreated": "2025-04-01T20:40:25.000+02:00",
        "repoKey": "ASctSKaar5.png",
        "locationId": 3283550,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3283550/ASctSKaar5.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283550/medium_ASctSKaar5.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3283550/thumb_ASctSKaar5.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing birmingham",
      "easymoney birmingham",
      "installment loans birmingham",
      "payday loans birmingham",
      "title loans birmingham"
    ],
    "labels": [
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-03-08T07:26:43.000+01:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/ccfi.easymoney"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "NEEDS_REVERIFICATION"
      }
    ],
    "visibilityIndex": 876,
    "dataPoints": 30,
    "linkedToLocationGroups": [
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "EasyMoney",
        "id": 1389
      }
    ],
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Chicago"
  },
  {
    "identifier": "22925",
    "id": 3615439,
    "dateCreated": "2022-12-09T23:19:45.000+01:00",
    "lastUpdated": "2025-04-03T01:49:02.000+02:00",
    "name": "Easy Money",
    "street": "Ann Street",
    "streetNo": "932",
    "streetAndNumber": "932 Ann Street",
    "addressExtra": null,
    "zip": "36107",
    "city": "Montgomery",
    "cellphone": null,
    "fax": "+1 334-265-1570",
    "website": "https://www.easymoneycashcenters.com/",
    "email": "customer.service@ccfi.com",
    "descriptionShort": null,
    "descriptionLong": "We provide hard working people with the fair cash solutions they need and deserve. Visit your neighborhood easymoney store at 932 Ann Street in Montgomery, AL. We offer Payday Loans, Title Pawn Loans and Installment Loans and applying is free. If you're approved, you can access cash quickly and easily. easymoney has got your back! Our store also offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Wire Transfers, Money Orders, and Bill Pay. The easymoney in Montgomery has been happily serving your neighborhood since 2014 and our mission is to always provide exceptional customer service!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:06:00.000+02:00",
    "country": "US",
    "lat": 32.36938281,
    "lng": -86.2714,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 334-293-9999",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 129167616,
        "dateCreated": "2024-07-02T16:46:38.000+02:00",
        "repoKey": "0Ar0dbaWuE.jpg",
        "locationId": 3615439,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3615439/0Ar0dbaWuE.jpg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615439/medium_0Ar0dbaWuE.jpg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615439/thumb_0Ar0dbaWuE.jpg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": null
      },
      {
        "id": 129167617,
        "dateCreated": "2024-07-02T16:46:39.000+02:00",
        "repoKey": "c4tkiKdKER.jpg",
        "locationId": 3615439,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "SQUARED_LOGO",
        "url": "/uploads/userpics/3615439/c4tkiKdKER.jpg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615439/c4tkiKdKER.jpg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615439/thumb_c4tkiKdKER.jpg",
        "cropHeight": 600,
        "cropWidth": 600,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      },
      {
        "id": 129167618,
        "dateCreated": "2024-07-02T16:46:40.000+02:00",
        "repoKey": "1NQSdsovkv.jpg",
        "locationId": 3615439,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "STOREFINDER_LOGO",
        "url": "/uploads/userpics/3615439/1NQSdsovkv.jpg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615439/medium_1NQSdsovkv.jpg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615439/thumb_1NQSdsovkv.jpg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": null
      },
      {
        "id": 129167619,
        "dateCreated": "2024-07-02T16:46:40.000+02:00",
        "repoKey": "TJ9yZNjhj5.jpg",
        "locationId": 3615439,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3615439/TJ9yZNjhj5.jpg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615439/TJ9yZNjhj5.jpg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615439/thumb_TJ9yZNjhj5.jpg",
        "cropHeight": 338,
        "cropWidth": 600,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      }
    ],
    "keywords": [
      "check cashing montgomery",
      "easymoney montgomery",
      "installment loans montgomery",
      "payday loans montgomery",
      "title loans montgomery"
    ],
    "labels": [
      {
        "name": "easymoney",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": false
      },
      {
        "name": "Alabama",
        "adminOnly": false
      }
    ],
    "categories": [
      465,
      1688,
      1145,
      1163,
      2693
    ],
    "locationSyncable": false,
    "businessId": 1591558,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-12-09T23:19:45.000+01:00",
    "averageRating": 4.1,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/speedycashus/"
      },
      {
        "externalId": "url_instagram",
        "displayName": "Instagram",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.instagram.com/therealspeedycash/"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      },
      {
        "externalId": "url_twitter",
        "displayName": "Twitter",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://x.com/speedycash/"
      },
      {
        "externalId": "url_youtube",
        "displayName": "Youtube",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.youtube.com/@speedycash/"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 40,
    "listingsBeingUpdated": 10,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "NEEDS_REVERIFICATION"
      }
    ],
    "visibilityIndex": 852,
    "dataPoints": 100,
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Chicago"
  },
  {
    "identifier": "22025",
    "id": 3615437,
    "dateCreated": "2022-12-09T23:19:45.000+01:00",
    "lastUpdated": "2025-04-04T02:49:30.000+02:00",
    "name": "Easy Money",
    "street": "University Drive Northwest",
    "streetNo": "4298",
    "streetAndNumber": "4298 University Drive Northwest",
    "addressExtra": null,
    "zip": "35816",
    "city": "Huntsville",
    "cellphone": null,
    "fax": "+1 256-895-8549",
    "website": "https://www.easymoneycashcenters.com/store/al/huntsville/4298-university-dr-nw",
    "email": "CustomerService@SpeedyCash.com",
    "descriptionShort": "Our store is located in Huntsville, AL just West of Fast Signs, Dairy Queen, and Arby's on the North side of University Dr NW. Start your application online to speed up the process once you arrive.",
    "descriptionLong": "We provide hard working people with the fair cash solutions they need and deserve. Visit your neighborhood easymoney store at 4298 University Dr. NW in Huntsville, AL. We offer Payday Loans, Title Pawn Loans and Installment Loans and applying is free. If you're approved, you can access cash quickly and easily. easymoney has got your back! Our store also offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Wire Transfers, Money Orders, Bill Pay and Gift Card Buyback. The easymoney in Huntsville has been happily serving your neighborhood since 2014 and our mission is to always provide exceptional customer service!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-01T20:45:44.000+02:00",
    "country": "US",
    "lat": 34.73539812,
    "lng": -86.63266781,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 256-217-5980",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 128599447,
        "dateCreated": "2024-06-11T20:59:21.000+02:00",
        "repoKey": "rWzvzNVKJM.jpg",
        "locationId": 3615437,
        "description": "",
        "identifier": null,
        "main": true,
        "logo": false,
        "type": "MAIN",
        "url": "/uploads/userpics/3615437/rWzvzNVKJM.jpg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615437/medium_rWzvzNVKJM.jpg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615437/thumb_rWzvzNVKJM.jpg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": null
      },
      {
        "id": 127067107,
        "dateCreated": "2024-04-12T00:23:26.000+02:00",
        "repoKey": "U8UgwfudAU.jpg",
        "locationId": 3615437,
        "description": "",
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "INTERIOR",
        "url": "/uploads/userpics/3615437/U8UgwfudAU.jpg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615437/medium_U8UgwfudAU.jpg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615437/thumb_U8UgwfudAU.jpg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": null
      },
      {
        "id": 139082308,
        "dateCreated": "2025-04-01T20:40:29.000+02:00",
        "repoKey": "Cb461Pe7o5.png",
        "locationId": 3615437,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3615437/Cb461Pe7o5.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615437/medium_Cb461Pe7o5.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3615437/thumb_Cb461Pe7o5.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://uberall-bulk-media-production.s3.eu-central-1.amazonaws.com/20250401204021/Lo9l02Gp7dyO.png"
      }
    ],
    "keywords": [
      "check cashing huntsville",
      "installment loans huntsville",
      "payday loans huntsville",
      "title loans huntsville",
      "easymoney huntsville"
    ],
    "labels": [
      {
        "name": "Mariana_Miller_Foley",
        "adminOnly": true
      },
      {
        "name": "Easy_Money",
        "adminOnly": true
      },
      {
        "name": "Alabama",
        "adminOnly": false
      },
      {
        "name": "EasyMoneyAL",
        "adminOnly": true
      }
    ],
    "categories": [
      465,
      1688,
      1145,
      1163,
      2693
    ],
    "locationSyncable": false,
    "businessId": 2014306,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-12-09T23:19:45.000+01:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2024-12-31",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-01-01",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 846,
    "dataPoints": 221,
    "province": "AL",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Chicago"
  }
]